import { customerApi } from '@api/customer.api';
import { Dealer } from '@api/types';
import { ADDRESS_TYPES } from '@components';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

const initialState: Dealer = {};

// REDUCERS
export const dealerSlice = createSlice({
  name: 'dealer',
  initialState,
  reducers: {
    setDealer: (state, action: PayloadAction<Dealer>) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(customerApi.endpoints.getDealerDetails.matchFulfilled, (state, action) => {
      return { ...state, ...action.payload.data };
    });
  },
});

const selectDealerState = (state: RootState) => state.dealer;

export const getDealer = createSelector(selectDealerState, (dealerState) => dealerState);

export const getDealerPublicAddress = createSelector(selectDealerState, (dealerState) => {
  return dealerState?.address?.find((address) =>
    address.addressType.includes(ADDRESS_TYPES.Public)
  );
});

// ACTIONS
export const { setDealer } = dealerSlice.actions;

export default dealerSlice.reducer;
